module.exports = __webpack_public_path__ + "static/img/governance1.e4fb3285.png";